import { createFrontendModule } from '@backstage/frontend-plugin-api';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';

const catalogGraphPage = catalogGraphPlugin
  .getExtension('page:catalog-graph')
  .override({
    factory(originalFactory, { config }) {
      return originalFactory({
        config: {
          ...config,
          initialState: {
            selectedKinds: config.selectedKinds,
            selectedRelations: config.selectedRelations,
            rootEntityRefs: config.rootEntityRefs,
            maxDepth: config.maxDepth,
            unidirectional: config.unidirectional,
            mergeRelations: config.mergeRelations,
            direction: config.direction,
            showFilters: config.showFilters,
            curve: config.curve,
          },
        } as typeof config,
      });
    },
  });

export const catalogGraphHomegateModule = createFrontendModule({
  pluginId: 'catalog-graph',
  extensions: [catalogGraphPage],
});
